import { useMemo, memo } from "react";
import MetaService from "../../../services/meta";

const Logo = memo(() => {
  const logo: string = useMemo(() => MetaService.logoUrl(false), []);

  return (
    <img
      src={logo}
      alt="logo"
      className="logo-cursor"
      width={102}
      height={24}
    />
  );
});

export default Logo;
